import { SEARCHER_OPTIONS, SEARCH_IMGS_ORDER_BY_OPTIONS } from './SEARCHER';
import { REPORT_TYPE } from './REPORTS';

/** @type {string} */
export const DATE_FILTERS_SEPARATOR = '-';

/** @type {string} */
export const FILTERS_SEPARATOR = ':';

/**
 * @type {{
 *  ALL: string,
 *  LAST_24_HOURS: string,
 *  LAST_7_DAYS: string,
 *  LAST_30_DAYS: string,
 *  LAST_12_MONTHS: string,
 *  CUSTOM_DATE_FROM: string
 *  CUSTOM_DATE_TO: string
 * }} FILTERS - Filters for the reports
 */
export const DATE_FILTERS = {
    ALL: 'datAll',
    LAST_24_HOURS: 'datLast24h',
    LAST_7_DAYS: 'datLast7d',
    LAST_30_DAYS: 'datLast30d',
    LAST_12_MONTHS: 'datLast12m',
    CUSTOM_DATE_FROM: `dat${DATE_FILTERS_SEPARATOR}from`,
    CUSTOM_DATE_TO: `dat${DATE_FILTERS_SEPARATOR}to`,
};

/**
 * @type {{
 * ED_ALL: string,
 * ED_IMGS: string,
 * ED_VIDEOS: string,
 * CR_ALL: string,
 * CR_IMGS: string,
 * CR_VIDEOS: string
 * CR_ILLUSTRATIONS: string,
 * CR_VECTORS: string,
 * }} FILE_TYPE_FILTER_KEYS - File type filter keys
 */
export const FILE_TYPE_FILTER_KEYS = {
    ED_ALL: SEARCHER_OPTIONS.ED_ALL,
    ED_IMGS: SEARCHER_OPTIONS.ED_IMGS,
    ED_VIDEOS: SEARCHER_OPTIONS.ED_VIDEOS,
    CR_ALL: SEARCHER_OPTIONS.CR_ALL,
    CR_IMGS: SEARCHER_OPTIONS.CR_IMGS,
    CR_VIDEOS: SEARCHER_OPTIONS.CR_VIDEOS,
    CR_ILLUSTRATIONS: SEARCHER_OPTIONS.CR_ILLUSTRATIONS,
    CR_VECTORS: SEARCHER_OPTIONS.CR_VECTORS,
};

/**
 * Array of filters allow trigging the search options.
 */
export const FILTERS_SYNCHRO_SEARCH_OPTIONS = {
    ...FILE_TYPE_FILTER_KEYS,
    ...REPORT_TYPE,
};

/**
 * Map the date filters to the API filters.
 * @type {{
 *  datLast24h: string,
 *  datLast7d: string,
 *  datLast30d: string,
 *  datLast12m: string,
 *  dat: string,
 * }}
 */
export const MAPPED_DATE_FILTERS = {
    [DATE_FILTERS.LAST_24_HOURS]: 'TODAY',
    [DATE_FILTERS.LAST_7_DAYS]: 'WEEK',
    [DATE_FILTERS.LAST_30_DAYS]: 'MONTH',
    [DATE_FILTERS.LAST_12_MONTHS]: 'YEAR',
    dat: 'DATE',
};

/**
 * Map the order by filters to the API filters.
 * @type {{
 *  new: number,
 *  old: number,
 *  cap: number,
 * }}
 */
export const MAPPED_ORDER_BY = {
    [SEARCH_IMGS_ORDER_BY_OPTIONS.NEW]: 0,
    [SEARCH_IMGS_ORDER_BY_OPTIONS.OLD]: 1,
    [SEARCH_IMGS_ORDER_BY_OPTIONS.CAP]: 2,
};

/**
 * Map the order by filters to the API filters.
 * @type {{
 *  new: string,
 *  old: string,
 *  cap: string,
 *  sim: string,
 * }}
 */
export const MAPPED_SORT_BY = {
    [SEARCH_IMGS_ORDER_BY_OPTIONS.NEW]: ['date', 'desc'],
    [SEARCH_IMGS_ORDER_BY_OPTIONS.OLD]: ['date', 'asc'],
    [SEARCH_IMGS_ORDER_BY_OPTIONS.CAP]: ['caption', 'asc'],
    [SEARCH_IMGS_ORDER_BY_OPTIONS.SIM]: ['similarity', 'desc'],
};

/**
 * @type {{
 *   TOTAL: string,
 *   DECLARATIONS: string,
 *   RESOURCES: string,
 * }} VIDEO_ED_TYPE - Video edition type
 */
export const MAPPED_VIDEO_ED_TYPE = {
    TOTAL: 'DECLARACIONES TOTALES',
    DECLARATIONS: 'DECLARACIONES RUEDAS DE PRENSA',
    RESOURCES: 'SONIDO AMBIENTE',
};

/**
 * @type {{
 *  IMG: string,
 *  VID: string,
 *  ILL: string,
 *  VEC: string,
 * }} FORMAT_SEARCH_NO_AI_TYPES - Format types
 */
export const FORMAT_SEARCH_NO_AI_TYPES = {
    IMG: 'Img',
    VID: 'Vid',
    ILL: 'Illustration',
    VEC: 'Vector',
};

/**
 * @type {{
 *   ONLY: string,
 *   NO_ONLY: string,
 * }} GENERATIVE_AI_TYPES - Generative AI types
 */
export const GENERATIVE_AI_TYPES = {
    ONLY: 'geneCrOnly',
    NO_ONLY: 'geneCrNon',
};

/**
 * @type {{
 *   ONLY: string,
 *   NON_ONLY: string,
 * }} PREMIUM_IMAGES_TYPES - Premium images types
 */
export const PREMIUM_IMAGES_TYPES = {
    ONLY: 'premiumCrOnly',
    NON_ONLY: 'premiumCrNon',
};

/**
 * Map the generative AI filters to the API filters.
 * @type {{
 *   geneCrOnly: number,
 *   geneCrNon: number,
 * }}
 */
export const MAPPED_GENERATIVE_AI_TYPES = {
    [GENERATIVE_AI_TYPES.ONLY]: 0,
    [GENERATIVE_AI_TYPES.NO_ONLY]: 1,
};

/**
 * Map the premium images filters to the API filters.
 * @type {{
 *   premiumCr: number,
 *   premiumCrNon: number,
 * }}
 */
export const MAPPED_PREMIUM_IMAGES_TYPES = {
    [PREMIUM_IMAGES_TYPES.ONLY]: 0,
    [PREMIUM_IMAGES_TYPES.NON_ONLY]: 1,
};

/**
 * @type {string} CUSTOM_FILTER_CHIP_AVATAR_TYPE - Custom filter chip avatar type
 */
export const CUSTOM_FILTER_CHIP_AVATAR_TYPE = 'familiar_face_and_zone';

/** @type {string} */
export const IMGS_FACES_SEPARATOR = '@';

/**
 * @type {{
 *   Img: number,
 *   Vid: number,
 *   Illustration: number,
 *   Vector: number,
 * }} SEARCHER_TYPE_FORMATS - Searcher type formats
 */
export const SEARCHER_TYPE_FORMATS = {
    [FORMAT_SEARCH_NO_AI_TYPES.IMG]: 1,
    [FORMAT_SEARCH_NO_AI_TYPES.VID]: 5,
    [FORMAT_SEARCH_NO_AI_TYPES.ILL]: 9,
    [FORMAT_SEARCH_NO_AI_TYPES.VEC]: 10,
};

/**
 * @type {{
 *   1: string,
 *   2: string,
 * }} MAPPED_ORIENTATION_TYPES - Mapped orientation types
 */
export const MAPPED_ORIENTATION_TYPES = {
    1: 'Vertical',
    2: 'Horizontal',
    3: 'Square',
    4: 'Panoramic',
};

/**
 * @type {{
 *  0: string,
 *  1: string,
 *  2: string,
 *  3: string,
 *  4: string,
 * }} MAPPED_TEMPLATE_TYPES - Mapped template types
 */
export const MAPPED_TEMPLATE_TYPES = {
    0: 'primer plano',
    1: 'medio plano',
    2: 'cuerpo entero',
    3: 'plano general',
    4: 'plano aéreo',
};

/**
 * @type {{
 *  0: string,
 *  1: string,
 *  2: string,
 *  3: string,
 * }} MAPPED_NUM_PEOPLE_TYPES - Mapped number of people types
 */
export const MAPPED_NUM_PEOPLE_TYPES = {
    0: 'Sin personas',
    1: 'Plano individual',
    2: 'Plano pareja',
    3: 'Plano de grupo',
};

/**
 * @type String[]
 * @description List of categories for the Performance filter type.
 */
export const PERFORMANCE_FILTER_CATEGORIE_OPTIONS = [
    'CINE',
    'TEATRO',
    'MUSICA',
    'RADIO',
    'TELEVISION',
    'PREMIOS CINEMATOGRAFICOS',
    'PREMIOS DE RADIO',
    'PREMIOS DE TELEVISION',
    'PREMIOS MUSICALES',
    'PREMIER PELICULAS',
    'PRESENTACIONES TEATRO',
    'PRESENTACIONES TELEVISION',
    'FESTIVALES DE TELEVISION',
    'FESTIVALES DE CINE',
    'FESTIVALES DE MUSICA',
    'CONCIERTOS MUSICALES',
    'PROGRAMAS DE TV',
    'PRESENTACIONES DISCOS',
    'OBRAS TEATRALES',
    'DANZA',
];
